module.exports = __webpack_public_path__ + "img/palvelusatama_original.26018f6c.jpg";